import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { reasonMaxLength, RejectReasonValidator } from '@models/models-validators/reject-reason-validator';

@Component({
    selector: 'app-reject-publish-dialog',
    templateUrl: './reject-publish-dialog.component.html',
    styleUrls: ['./reject-publish-dialog.component.css'],
    standalone: false,
})
export class RejectPublishDialogComponent {
    readonly REJECTREASON_MAX_LENGTH = reasonMaxLength;
    rejectReason: string;

    constructor(private dialogRef: MatDialogRef<RejectPublishDialogComponent>) {}

    cancel() {
        this.dialogRef.close();
    }

    rejectPublish() {
        if (this.isButtonDisabled()) return;
        this.dialogRef.close(this.rejectReason);
    }

    isButtonDisabled(): boolean {
        return !this.rejectReason || this.rejectReason?.length > 200;
    }

    public get validatorFunction() {
        return RejectReasonValidator;
    }
}
